<script>
export default {
  props: {
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    includeActions() {
      return (
        !!this.$slots['card-actions-left'] ||
        !!this.$slots['card-actions-right']
      )
    },
  },
}
</script>

<template>
  <VCard :color="color" flat>
    <VCardText class="px-4">
      <slot />
    </VCardText>

    <VDivider v-if="includeActions" />

    <VCardActions v-if="includeActions" class="grey lighten-4 px-4">
      <slot name="card-actions-left" />
      <VSpacer />
      <slot name="card-actions-right" />
    </VCardActions>
  </VCard>
</template>
